/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgDividerSquareDashBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 20.5714C22 20.9503 21.8495 21.3137 21.5816 21.5816C21.3137 21.8495 20.9503 22 20.5714 22M20.5714 2C20.9503 2 21.3137 2.15051 21.5816 2.41842C21.8495 2.68633 22 3.04969 22 3.42857M2 3.42857C2 3.04969 2.15051 2.68633 2.41842 2.41842C2.68633 2.15051 3.04969 2 3.42857 2M3.42857 22C3.04969 22 2.68633 21.8495 2.41842 21.5816C2.15051 21.3137 2 20.9503 2 20.5714M6.28571 2H7.71429M10.5714 2H13.4286M16.2857 2H17.7143M6.28571 22H7.71429M10.5714 22H13.4286M16.2857 22H17.7143M2 6.28571V7.71429M2 10.5714V13.4286M2 16.2857V17.7143M22 6.28571V7.71429M22 10.5714V13.4286M22 16.2857V17.7143M2 12H22"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgDividerSquareDash = wrapIcon(SvgDividerSquareDashBase);
export default SvgDividerSquareDash;
